import React from 'react'
import i18n from 'live/services/i18n'
import xhr from 'live/services/xhr'
import AdminHeader from 'live/components/header/ui/admin/header'
import logger from 'live/services/logger'
import Clipboard from 'clipboard'
import GlobalAlert from 'live/components/ui/global-alert'
import { FormEnabledContext } from 'live/context/form-enabled'

export default class Main extends React.Component {
    static contextType = FormEnabledContext
    constructor (props) {
        super(props)

        this.state = {
            loading: true
        }
    }

    UNSAFE_componentWillMount () {
        this.get()
    }

    componentDidMount () {
        document.title = 'Live: ' + i18n('Pressure Tests Specification')

        const menuCopyLink = this.clipboardContainer
        const component = this
        const clipboard = new Clipboard(menuCopyLink, {
            text () {
                component.setState({ showClipboardNotification: true })
                return component.clipboardTarget.textContent
            }
        })

        clipboard.on('error', logger.error)
    }

    get = (callback = false) => {
        this.setState({loading: true, html: false, error: false})

        xhr.get('/services/plugin-pressuretests/pressure_tests/list')
            .then((response) => {

                xhr.post('/services/plugin-petrobras/pressureTestsSpecification', response.data)
                    .then((response) => {
                        this.setState({
                            html: response.data.html,
                            loading: false
                        })
                    })
                    .catch((response) => {
                        this.setState({
                            html: i18n('Error creating Pressure Tests Specification') + ":<br />" + response.error,
                            loading: false
                        })
                    })

            })
            .fail((response) => {
                this.setState({
                    html: i18n('Error loading Pressure Tests configurations'),
                    loading: false
                })
            })
    }

    configurePressureTests = () => {
        location.href = "/admin/#platform"
    }

    render () {
        const {html, loading, error} = this.state
        const { readonly } = this.context
        return (
            <div className={'pressure-tests-specification admin-content ' + (loading ? 'loading' : '')}>
                <div className='admin-inner'>
                    <AdminHeader>
                        <h2>
                            <span>{i18n('Pressure Tests Specification')}</span>
                        </h2>
                    </AdminHeader>

                    <div className='admin-body'>

                        <div className="header">
                            <div className="buttons">
                                <button ref={ref => { this.clipboardContainer = ref }} className={'btn btn-primary'}>
                                    <span><i className="fa fa-copy"></i> {i18n('Copy content to clipboard')}</span>
                                </button>
                                <button className={'btn'} onClick={this.configurePressureTests} disabled={readonly}>
                                    <span><i className="fa fa-cog"></i> {i18n('Configure Pressure Tests')}</span>
                                </button>
                                <button className={'btn'} onClick={this.get}>
                                    <span><i className="fa fa-refresh"></i> {i18n('Refresh')}</span>
                                </button>
                            </div>
                        </div>

                        <hr/>

                        <div className="pressure-tests-specification-container">
                            {loading
                                ? <div><i className="fa fa-spinner" aria-hidden="true"></i></div>
                                : error
                                    ? <div className="error">{error}</div>
                                    : html
                                        ? <div ref={ref => { this.clipboardTarget = ref }} dangerouslySetInnerHTML={{__html: html}} />
                                        : ''}
                        </div>
                    </div>
                </div>

                <GlobalAlert
                    className="alert-sm alert--dashboard-more-options success"
                    visibleTime={3}
                    message={i18n('Specification successfully copied to the clipboard.')}
                    show={this.state.showClipboardNotification}
                    onClose={() => this.setState({ showClipboardNotification: false })} />
            </div>
        )
    }

}
